import { render } from "./SmsStack.vue?vue&type=template&id=783c651c"
import script from "./SmsStack.vue?vue&type=script&lang=js"
export * from "./SmsStack.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/karman/karman_crm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__